import IndustryDetailPage from "@/pages/industries/components/IndustryDetailPage";

export default function RealEstatePage() {
  return <IndustryDetailPage slug="real-estate" />;
}